export const TRACE_ID_SCRIPT_TYPE = 'text/x-traceid';

export const getTraceID = () => {
  const element = document.querySelector(`script[type="${TRACE_ID_SCRIPT_TYPE}"]`);

  return element?.textContent?.trim() || null;
};
